import { useAppDispatch, useAppSelector } from '@hooks/redux';
import {
  fetchTotalWorkspaceIndexes as fetchTotalWorkspaceIndexesAction,
  selectFetchTotalWorkspaceIndexesStatus,
  selectTotalWorkspaceIndexes,
} from '../redux/indexesSlice';

const useWorkspaceIndexes = () => {
  const dispatch = useAppDispatch();

  const totalWorkspaceIndexes = useAppSelector(selectTotalWorkspaceIndexes);
  const fetchTotalWorkspaceIndexesStatus = useAppSelector(selectFetchTotalWorkspaceIndexesStatus);

  const fetchTotalWorkspaceIndexes = () => {
    dispatch(fetchTotalWorkspaceIndexesAction());
  };

  return {
    fetchTotalWorkspaceIndexesStatus,
    totalWorkspaceIndexes,
    fetchTotalWorkspaceIndexes,
  };
};

export default useWorkspaceIndexes;
